import React, { useState } from 'react';
import { useEffect } from 'react';
import './CustomToast.css';

export default function ToastComponent({title, content, type}) {
    const [iconType, setIconType] = useState("fa-solid fa-exclamation");

    useEffect(()=>{
        switch (type) {
            case 'user':
                setIconType("fa-solid fa-circle-user");
                break;
            default:
                setIconType("fa-solid fa-square-exclamation")
                break;
        }
    },[])
    
  return (
    <div className='custom-toast'>
        <h6 className='custom-toast-header'><i className={iconType}></i> {title}</h6>
        <span>{content}</span>
    </div>
  )
}